import { render } from "./ModalEvento.vue?vue&type=template&id=139a8c8c&scoped=true"
import script from "./ModalEvento.vue?vue&type=script&lang=js"
export * from "./ModalEvento.vue?vue&type=script&lang=js"

import "./ModalEvento.vue?vue&type=style&index=0&id=139a8c8c&scoped=true&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139a8c8c"]])

export default __exports__